import { IConfig } from "shared/types/configuration";
import { IClientError } from "shared/types/errors";
import HttpClient from "./httpClient";

export default ({ config }: { config: IConfig }) => ({
  postClientError: <T>(clientError: IClientError): Promise<T> => {
    return HttpClient.post(config.services.postClientErrorUrl, clientError);
  },
});
